import styled from 'styled-components';

const Clearfix = styled.div`
  :before,
  :after{
    display: table;
    content: " ";
  }

  :after{
    clear: both;
  }
`;

export default Clearfix;



// WEBPACK FOOTER //
// ./src/shared-components/atoms/Clearfix/index.js